import React, { useEffect, useState } from 'react';
import type { Linktree } from 'types/linktree';

import Image from 'next/image';

import { Wrap } from '@leafwell/components';
import { slugify } from 'lib/utils/slugify';

const LinktreeContent: React.FC<{ linktree: Linktree }> = ({ linktree }) => {
  const categories = linktree.categories;
  const [activeHash, toggleHash] = useState('#');
  useEffect(() => {
    const pageHash = window.location.hash ? window.location.hash : '#';
    toggleHash(pageHash);
  }, []);

  return (
    <div className="bg-gray-100 scroll-smooth">
      <Wrap size="small">
        <nav className="border-b border-gray-400 overflow-hidden">
          <ul className="w-full flex md:justify-center -mb-4 md:-mb-8 pt-1 pb-8 md:pb-16 text-sm overflow-x-scroll">
            <li className="mx-2 md:mx-4">
              <a
                href="#"
                onClick={() => toggleHash('#')}
                className={`block md:py-1 px-3 md:px-4 border border-gray-400 rounded-lg font-medium whitespace-nowrap duration-500 ${
                  activeHash === '#'
                    ? 'bg-black text-white'
                    : 'hover:bg-black hover:text-white'
                }`}
              >
                All
              </a>
            </li>

            {categories?.length &&
              categories?.map(({ categoryName }, key) => {
                const id = slugify(categoryName);
                const activeClasses =
                  activeHash === `#${id}`
                    ? 'bg-black text-white'
                    : 'hover:bg-black hover:text-white';

                return (
                  <li id={key.toString()} className="mx-2 md:mx-4">
                    <a
                      href={`#${id}`}
                      onClick={() => toggleHash(`#${id}`)}
                      className={`block md:py-1 px-3 md:px-4 border border-gray-400 rounded-lg font-medium  whitespace-nowrap duration-500 ${activeClasses}`}
                    >
                      {categoryName}
                    </a>
                  </li>
                );
              })}
          </ul>
        </nav>

        <ul className="max-w-sm md:max-w-lg mx-auto w-full px-5">
          {categories?.length &&
            categories?.map(
              ({ categoryName, contentType, posts, otherLinks }) => {
                const id = slugify(categoryName);
                const isPosts = contentType === 'posts';
                const content = isPosts ? posts : otherLinks;

                return (
                  <li id={id} className="mb-16 md:mb-20">
                    <h2 className="mb-4 md:mb-4 text-lg md:text-2xl leading-tight font-sans prose">
                      {categoryName}
                    </h2>
                    <ul>
                      {content?.length &&
                        content?.map((el, key) => {
                          const url = isPosts ? el.uri : el.url;
                          const thumb = isPosts
                            ? el.featuredImage.src
                              ? el.featuredImage.src
                              : '/bg_default.svg'
                            : el.image
                            ? el.image.src
                            : '/bg_default.svg';
                          return (
                            <li
                              className="mb-3 md:mb-4 p-2 md:p-4 rounded-xl bg-white"
                              id={key}
                            >
                              <a
                                href={url}
                                target="_blank"
                                className="flex items-center justify-between pr-2"
                              >
                                <div className="flex items-center pr-4">
                                  <Image
                                    src={thumb}
                                    quality={60}
                                    className="h-14 w-14 shrink-0 rounded-lg mr-4"
                                    alt={el.title}
                                    width={56}
                                    height={56}
                                  />
                                  <p className="text-xs md:text-sm font-medium">
                                    {el.title}
                                  </p>
                                </div>
                                <Image
                                  width={15}
                                  height={12}
                                  src="/arrow.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  </li>
                );
              },
            )}
        </ul>
      </Wrap>
    </div>
  );
};

export default LinktreeContent;
